module.exports = __webpack_public_path__ + "static/media/icon_caalender_left.c9c1fae6.svg";